import { adminApi } from "../http/httpClient";

export type ContactScreen = "more" | "login";

export type ContactConfig = {
  buttonLabel: string;
  title: string;
  description: string;
  subjects: string[];
};

export async function fetchContactConfig(
  screen: ContactScreen,
): Promise<Partial<ContactConfig>> {
  const { data } = await adminApi.get<Partial<ContactConfig>>(
    "/contact/subjects",
    { params: { screen } },
  );

  return data ?? {};
}
